module.exports = __webpack_public_path__ + "img/acount_des_2.5da8277d.jpg";